import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Api } from './../../api/api';
import { config } from './../../api/config';
import styles from './deleteComfirmationModal.module.scss';
import { Button, WithSpinner } from '../../components';
import { actions } from '../../state/actions';
import { history } from './../../App';
import swal from 'sweetalert';

const AdditionalVmiCheckConfirmation = ({
  open,
  filter,
  additionalCheckSelection,
  loading,
  dispatch,
}) => {
  const [isLoading, setIsloading] = useState(false);

  const forwardTo = (location) => {
    history.push(location);
    window.location.reload();
  };
  const closeModal = {
    modalName: 'additionalVmiCheckConfirmation',
    visible: false,
  };

  const cancel = () => {
    dispatch(actions.modals.setModalVisibleFlagAction(closeModal));
  };

  const returnEndpoint = () => {
    if (additionalCheckSelection === 'MarkForVmiRenew') {
      return Api.API_BASE_URL + config.API_ENDPOINTS.MarkForVmiRenewMass;
    } else {
      return (
        Api.API_BASE_URL + config.API_ENDPOINTS.MarkForVmiAdditionalCheckMass
      );
    }
  };

  const yes = () => {
    console.log(filter);

    fetch(returnEndpoint(), {
      method: 'POST',

      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',

        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(filter),
    })
      .then((res) => {
        if (res.ok === true) {
          cancel();

          swal({
            title: 'Įvykdyta',
            icon: 'success',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn btn-pink',
                closeModal: true,
              },
            },
          });
        } else if (res.status === 403) {
          swal({
            title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
            icon: 'error',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn swal-ok-btn',
                closeModal: true,
              },
            },
          });
        } else {
          res.json().then((r) => {
            // dispatch(actions.backoffice.callSagaForErrHandling(r));

            console.log(r);

            swal({
              title: `${
                r.ErrorDescription ? r.ErrorDescription : 'Įvyko klaida'
              }`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsloading(false);
      });
  };
  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
        >
          <WithSpinner loading={loading}>
            {additionalCheckSelection === 'MarkForVmiRenew' ? (
              <h2>
                Ar tikrai norite užklausti apyvartų kritimo išfiltruotoms
                įmonėms?
              </h2>
            ) : (
              <h2>
                Ar tikrai norite papildomai užklausti apyvartų išfiltruotoms
                įmonėms?
              </h2>
            )}

            <div className={styles.btnContainer}>
              <Button type="standart" onClick={() => yes()}>
                Taip
              </Button>
              <Button type="cancel" onClick={() => cancel()}>
                Atšaukti
              </Button>
            </div>
          </WithSpinner>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboardState.isOnSync,
});

export default connect(mapStateToProps)(AdditionalVmiCheckConfirmation);
